// Referral codes withdrawn without a replacement: links carrying them no longer credit a referral.
// The agent gets a working code back by generating a new one (POST /api/am/referral-code).
// PARS954: Parsa Rezayi's invite links went out as referral links by mistake (30 Oct 2026).
export const RETIRED_AGENT_REFERRAL_CODES: readonly string[] = ['PARS954'];

// Generated codes are <agentReference>-<suffix>, so they never collide with an agentReference (no hyphen).
export const GENERATED_REFERRAL_SUFFIX_LENGTH = 4;
